import { Row } from '@cdab/scania/qpr/components/atoms'
import styled from 'styled-components'

export const StyledRow = styled(Row)`
  margin-top: 8px;
  margin-bottom: 8px;
`

export const FullWidth = styled.div`
  width: 100%;
`

export const MessagesRow = styled(Row)`
  flex-direction: column;
`

export const StyledMessage = styled.div`
  flex: auto;
`

export const StyledFirstRow = styled(Row)`
  padding-top: 20px;
`
